import { Quote } from "lucide-react";
import { useT } from "@/i18n/LangProvider";

export default function Testimonials() {
  const { t } = useT();
  const items = t("testimonials.items") || [];

  return (
    <section
      id="testemunhos"
      data-testid="testimonials-section"
      className="section starfield-subtle relative"
      style={{ background: "var(--navy-deep)" }}
    >
      <div className="section-inner relative z-10">
        <p className="eyebrow fade-up">{t("testimonials.eyebrow")}</p>
        <h2
          className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 mb-16 max-w-4xl fade-up"
          data-testid="testimonials-title"
        >
          {t("testimonials.title")}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {items.map((tt, i) => (
            <article
              key={tt.name}
              className="fade-up relative group flex flex-col p-8"
              data-testid={`testimonial-card-${i}`}
              style={{
                background: "var(--navy-mid)",
                border: "1px solid rgba(184,150,46,0.15)",
                borderTop: "2px solid rgba(184,150,46,0.35)",
                transition: "all 0.35s ease",
              }}
            >
              <div
                className="absolute -top-[2px] left-0 right-0 h-[2px] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500"
                style={{ background: "var(--gold-light)" }}
              />

              <Quote
                className="w-8 h-8 text-[color:var(--gold)] opacity-40 mb-6"
                strokeWidth={1}
              />

              <blockquote className="font-serif text-lg md:text-xl leading-relaxed text-[color:var(--white)] italic flex-1 mb-8">
                “{tt.quote}”
              </blockquote>

              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-[rgba(184,150,46,0.15)]">
                <div
                  className="w-11 h-11 rounded-full flex items-center justify-center font-mono-brand text-xs flex-shrink-0"
                  style={{
                    background: "rgba(184,150,46,0.12)",
                    border: "1px solid var(--gold)",
                    color: "var(--gold-light)",
                  }}
                  aria-hidden="true"
                >
                  {tt.initials}
                </div>
                <div>
                  <p className="font-sans-brand text-sm text-[color:var(--white)] leading-tight font-medium">
                    {tt.name}
                  </p>
                  <p className="font-mono-brand text-[0.62rem] text-[color:var(--gold-light)] mt-1">
                    {tt.role}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
